var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { SelectorIcon, XIcon } from '../icons/index.js';
import { useFloatingContext } from '../utils/floating/index.js';
import { useInputColors } from '../utils/styles/index.js';
import { useSearchableSelect } from './SearchableSelectContext.js';
export const SearchableSelectButton = forwardRef((props, ref) => {
    const { children, className, placeholder, dense = false, hideIcon = false, hideClearIcon = false } = props, rest = __rest(props, ["children", "className", "placeholder", "dense", "hideIcon", "hideClearIcon"]);
    const { inputValue, disabled, invalid, getComboboxProps, getInputProps, getToggleButtonProps, selectedItem, reset, } = useSearchableSelect();
    const { reference } = useFloatingContext();
    const { backgroundClsx, borderClsx, invalidClsx, disabledClsx, iconClsx, placeholderClsx, focusClsx, fontClsx, } = useInputColors({
        invalid,
        disabled,
    });
    const clearButton = (React.createElement("button", { type: "button", className: "absolute inset-y-0 end-0 flex items-center px-2 rounded-md", "aria-label": "clear selection", onClick: e => {
            e.stopPropagation();
            reset();
        } },
        React.createElement(XIcon, { className: clsx('w-5 h-5', iconClsx), "aria-hidden": "true" })));
    const toggleButton = (React.createElement("span", { className: "absolute inset-y-0 end-0 flex items-center pe-2 pointer-events-none", "aria-label": "toggle menu" },
        React.createElement(SelectorIcon, { className: clsx('w-5 h-5', iconClsx), "aria-hidden": "true" })));
    const onKeyDown = event => {
        if (event.key === 'Backspace' && !inputValue) {
            reset();
        }
    };
    const getIcon = () => {
        if (dense || hideIcon) {
            return null;
        }
        if (selectedItem) {
            if (hideClearIcon) {
                return null;
            }
            return clearButton;
        }
        return toggleButton;
    };
    return (React.createElement("div", { ref: reference },
        React.createElement("div", Object.assign({ className: clsx('block w-full rounded-md group relative', 'py-2 text-start cursor-default', [
                'appearance-none',
                'text-base',
                fontClsx,
                backgroundClsx,
                !dense && borderClsx,
                !dense && focusClsx,
                invalid && invalidClsx,
                disabled && disabledClsx,
            ], !dense && 'ps-3 pe-10', className) }, getComboboxProps(getToggleButtonProps(Object.assign({ disabled, ref }, rest)))),
            React.createElement("span", { className: "block truncate" },
                React.createElement("div", { className: "flex space-s-2" },
                    selectedItem && !inputValue && (React.createElement("div", { className: "min-w-0" }, children)),
                    React.createElement("input", Object.assign({ className: clsx('focus:outline-none bg-transparent flex-1 overflow-hidden', 'text-base', fontClsx, placeholderClsx) }, getInputProps({
                        placeholder: selectedItem ? '' : placeholder,
                        disabled,
                        onKeyDown,
                    }))))),
            getIcon())));
});
//# sourceMappingURL=SearchableSelectButton.js.map